import React from 'react';

export default () => (
  <div className="c-heading c-heading--small u-mt">
    No discounts are currently set up. To add a discount please click on the&nbsp;
    Add Discount button in the top right corner.
  </div>
);
